import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsFeaturesRoute: InvariantJiraRoute = {
	name: 'classic-software-features',
	path: '/jira/software/c/projects/:projectKey/settings/features',
	exact: true,
};
